import { render, staticRenderFns } from "./NewPost.vue?vue&type=template&id=24b1a7f3&scoped=true&"
import script from "./NewPost.vue?vue&type=script&lang=js&"
export * from "./NewPost.vue?vue&type=script&lang=js&"
import style0 from "./NewPost.vue?vue&type=style&index=0&id=24b1a7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1a7f3",
  null
  
)

export default component.exports